// extracted by mini-css-extract-plugin
export default {"date":"RecentSaleTimeStamp__date-Z9qi"};